import { combineReducers } from "redux";
import { webhookResource } from "./webhook/webhook.reducers";

export const additionalResources = combineReducers({
    webhookResource
});